import BehaviorActionTypes from '../../constants/behavior_action_types';

import BehaviorAction from './behavior_action';
import BehaviorSetPropertyAction from './behavior_set_property_action';
import BehaviorScriptAction from './behavior_script_action';
import BehaviorCancelEventAction from './behavior_cancel_event_action';

export const create = (behaviorActionProps) => {
	const behaviorActionClass = getModelClass(behaviorActionProps.type);
	return new behaviorActionClass(behaviorActionProps);
};

export const getModelClass = (behaviorActionType) => {
	switch(behaviorActionType) {
		case BehaviorActionTypes.SET_PROPERTY:
			return BehaviorSetPropertyAction;
		case BehaviorActionTypes.SCRIPT:
			return BehaviorScriptAction;
		case BehaviorActionTypes.CANCEL_EVENT:
			return BehaviorCancelEventAction;
		default:
			return BehaviorAction;
	}
};

export default {
	create,
	getModelClass,
};
